import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ds-segmented-picker__widget"
}

import { inject } from "vue";
import { dsSegmentedInjectedKey } from "../segmented-picker/ds-segmented-injected-key";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-segmented-picker-item',
  props: {
    title: {},
    name: {}
  },
  setup(__props: any) {



const selectedTabName = inject(dsSegmentedInjectedKey);

return (_ctx: any,_cache: any) => {
  return (_ctx.$slots.default)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)), [
        [_vShow, _ctx.name === _unref(selectedTabName)]
      ])
    : _createCommentVNode("", true)
}
}

})